import { Card, Flex, Space, Typography } from 'antd'
import React from 'react'
import { primaryColor } from '../store/slice/ContentSlice'
import { useSelector } from 'react-redux'

const { Text } = Typography

export default function ProductFeature({ icon, name, amount, unit }) {
  const primary = useSelector(primaryColor)

  return (
    <Card
      style={{
        borderTop: `3px solid ${primary}`,
        textAlign: 'center',
        boxShadow: '1px 1px 10px #00000050',
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 145,
        width: '32%',
        minWidth: 100,
      }}
      size='small'
    >
      <Flex vertical align='center' justify='center' gap={5} style={{ textAlign: 'center' }}>
        <img src={icon} alt={name} style={{ width: window.innerWidth < 768 ? 50 : 66 }} />
        <Text>{name}</Text>
        {amount && unit && parseFloat(amount) > 0 && <Text>{amount} {unit}</Text>}
      </Flex>
    </Card>
  )
}
